import React from 'react';
import { Card, CardContent } from '../../components/ui/card';
import { Button } from '../../components/ui/button';

const logoSizeClasses = {
  small: 'h-12',
  medium: 'h-16',
  large: 'h-24',
  very_large: 'h-32',
};

export default function SurveyLandingPage({ 
  branding, 
  languageSettings, 
  organizationName, 
  onSelectLanguage,
  apiBase 
}) {
  const logoUrl = branding?.logo_url 
    ? (branding.logo_url.startsWith('http') ? branding.logo_url : `${apiBase}${branding.logo_url}`)
    : null;

  return (
    <div className="min-h-screen flex items-center justify-center p-4"
      style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0f172a 100%)' }}
    >
      <Card className="w-full max-w-sm bg-white shadow-2xl border-0 overflow-hidden" data-testid="language-landing-page">
        {/* Logo */}
        {logoUrl && (
          <div className="flex justify-center pt-8 pb-2 px-6">
            <img
              src={logoUrl}
              alt={organizationName || 'Logo'}
              className={`object-contain ${logoSizeClasses[branding?.logo_size] || logoSizeClasses.medium}`}
              onError={(e) => { e.target.style.display = 'none'; }}
            />
          </div>
        )}

        <CardContent className="px-6 pb-8 pt-4 text-center space-y-6">
          {/* Property Name */}
          {languageSettings?.show_property_name && organizationName && (
            <p className="text-lg font-semibold text-gray-800" data-testid="landing-property-name">
              {organizationName}
            </p>
          )}

          {/* Welcome Message */}
          <p className="text-base text-gray-600" data-testid="landing-welcome-text">
            {languageSettings?.welcome_message || 'Welcome / Bienvenue'}
          </p>

          {/* Language Buttons */}
          <div className="space-y-3 pt-2">
            <Button
              onClick={() => onSelectLanguage('en')}
              className="w-full h-14 text-base font-medium bg-emerald-600 hover:bg-emerald-700 text-white rounded-xl shadow-md"
              data-testid="landing-select-english"
            >
              For English, press here
            </Button>

            <Button
              onClick={() => onSelectLanguage('fr')}
              className="w-full h-14 text-base font-medium bg-blue-600 hover:bg-blue-700 text-white rounded-xl shadow-md"
              data-testid="landing-select-french"
            >
              Pour le français, appuyez ici
            </Button>

            <Button
              onClick={() => onSelectLanguage('es')}
              className="w-full h-14 text-base font-medium bg-amber-600 hover:bg-amber-700 text-white rounded-xl shadow-md"
              data-testid="landing-select-spanish"
            >
              Para español, presione aquí
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
